/* eslint-disable @typescript-eslint/lines-between-class-members */
export class RegExEnum {
	public static A_TO_Z = /^[A-Za-z]$/;
	public static ALPHANUMERIC = /^[a-zA-Z0-9]+$/;
	public static POSTCODE = /^[0-9]{4}/;
}
